module.exports = __webpack_public_path__ + "img/error.5dd4ccd4.svg";